<template>
  <div v-if="this.$store.getters.cargo == 'aluno'" class="div-credits">
    <img class="i-credits" src="../../assets/images/icon-color/coins.svg" />
    <ul class="credits-info" style="margin-top:15px;">
      <li>Créditos:</li>
      <li>Disponível: {{ aluno.credito_disponivel }}</li>
    </ul>
  </div>
  <div v-else-if="this.$store.getters.cargo == 'corretor'" class="div-credits">
    <img class="i-credits" src="../../assets/images/icon-color/coins.svg" />
    <ul class="credits-info">
      <li>Créditos:</li>
      <li>Total: {{ corretor.total }}</li>
      <li>Pagos: {{ corretor.pago }}</li>
      <li>A receber: {{ corretor.receber }}</li>
    </ul>
  </div>
  <div v-else-if="this.$store.getters.cargo == 'diretor'" class="div-credits">
    <img class="i-credits" src="../../assets/images/icon-color/coins.svg" />
    <ul class="credits-info">
      <li>Créditos:</li>
      <li>Comprados: {{ diretor.escola.credito_comprado }}</li>
      <li>Atribuídos: {{ diretor.escola.credito_atribuido }}</li>
      <li>utilizado: {{ diretor.escola.credito_ultilizado }}</li>
      <li>Disponível: {{ diretor.escola.credito_disponivel }}</li>
    </ul>
  </div>
</template>
<script>
import DiretorService from "@/services/DiretorService";
import AlunoService from "@/services/AlunoService";
import CorretorService from "@/services/CorretorService";

export default {
  data() {
    return {
      escola: [],
      aluno: [],
      corretor: [],
      diretor: []
    };
  },
  created() {
    switch (this.$store.getters.cargo) {
      case "aluno":
        AlunoService.Info(this.$store.getters.cargo_id).then(result => {
          this.aluno = result.data;
        });
        break;
      case "corretor":
        CorretorService.Info(this.$store.getters.cargo_id).then(result => {
        this.corretor = result.data;
      });
        break;
      case "diretor":
        DiretorService.Info(this.$store.getters.cargo_id).then(
          result => {
            this.diretor = result.data;
          }
        );
        break;
    }
  },
  name: "credits"
};
</script>